module.exports = __webpack_public_path__ + "static/media/8.64b56bd9.jpg";